import { atom } from "recoil";
export const currentSelectedRoleState = atom({
    key: "currentSelectedRoleState", // unique ID (with respect to other atoms/selectors)
    default: "", // default value (aka initial value)
});
